import React, { useContext, useEffect, useRef, useState } from 'react';
import { Form, Input, InputNumber, Select } from 'antd';
import EditableContext from './EditableContext';




const EditableCell = ({title, editable, children, options, dataIndex, record, inputType, handleSave, ...restProps }) => {
  const [editing, setEditing] = useState(false);
  const inputRef = useRef(null);
  const form = useContext(EditableContext);

  

  useEffect(() => {
    if (editing) {
      inputRef.current?.focus();
    }
  }, [editing]);
  

  useEffect(() => {
    if (record) {
      const value = form.getFieldValue(`${dataIndex}${record.key}`);
      // console.log(value)
      if (value === undefined && options) {
        // let id = record
        let account = options.find(opt => opt.value === record[dataIndex]);
        
        if (account !== undefined) {
          form.setFieldValue(`${dataIndex}${record.key}`, account.label);
        }
      }
    }
  },[])

  const toggleEdit = () => {
    setEditing(!editing);
    form.setFieldsValue({
      [dataIndex]: record[dataIndex],
    });
  };

  const save = async () => {
    try {
      const values = await form.validateFields();
      toggleEdit();
      handleSave({...record, ...values}, form);
    } catch (errInfo) {
      console.log('Save failed:', errInfo);
    }
  };

  const onChange = (v, opt) => {
    form.setFieldValue(`${dataIndex}${record.key}`, opt.label );
    if (record.description !== undefined) {
      console.log('set description')
      form.setFieldValue(`description`, opt.label);
    }

    if (dataIndex === 'product_id' && opt.cost !== undefined) {
      form.setFieldValue(`price`, parseFloat(opt.cost));
    }
  }
  let childNode = children;

  if (editable) {
    childNode = editing ? (
      <Form.Item className='m-0' name={dataIndex}>
        {inputType === 'select' ?
        <Select ref={inputRef} options={options} onChange={onChange} style={{width: '100%'}} onBlur={save} /> :
        inputType === 'number' ?
        <InputNumber ref={inputRef} className='input-outline-none w-full' onPressEnter={save} onBlur={save}  /> :
        <Input ref={inputRef} className='input-outline-none w-full' onPressEnter={save} onBlur={save} />}
      </Form.Item>
    ) : (
      <div className="editable-cell-value-wrap" onClick={toggleEdit} >
        {
          (inputType === 'select' && dataIndex === 'location_src_id') ? form.getFieldValue(`${dataIndex}${record.key}`) : 
          (inputType === 'select' && dataIndex === 'location_dest_id') ? form.getFieldValue(`${dataIndex}${record.key}`) : 
          (inputType === 'select' && dataIndex.includes('_id')) ? form.getFieldValue(`${dataIndex}${record.key}`) : 
          
          children
        }
      </div>
    );
  }
  return <td {...restProps} className={editing ? 'py-0' : 'py-1'} onClick={!editing ? toggleEdit : (e)=>{e.preventDefault(); e.stopPropagation();}}>{childNode}</td>;
};



export default EditableCell;